import styled from "@emotion/styled";

import SEOHelmet from "@/components/helpers/seo/SEOHelmet";
import { Box } from "@/components/layout/flexbox";
import PublicFooter from "@/components/nav/PublicFooter";
import PublicNav from "@/components/nav/PublicNav";
import { BRAND_PURPLE, SITE_NAME } from "@/css/constants";

import Faq from "./Faq";

export default function FaqPage() {
  return (
    <>
      <SEOHelmet
        title={`${SITE_NAME} Frequently Asked Questions`}
        description={`Read the answers to questions frequently asked about ${SITE_NAME}.`}
        canonicalPath="/faq"
        canonicalDomain={WEB_APP}
        bodyAttributes={{ class: "public-site" }}
      />
      <PublicNav />
      <StyledContainer>
        <div className="public-content content-page">
          <Box maxWidth={700} className="text-center" margin="120px auto 0">
            <h1 style={{ fontSize: 70 }}>Frequently asked questions</h1>
          </Box>
          <Faq />
        </div>
      </StyledContainer>
      <PublicFooter />
    </>
  );
}

const StyledContainer = styled.div`
  .hero-content h1 {
    color: ${BRAND_PURPLE};
  }
`;
